(function () {
  var lastFired = 0;

  function triggerCartExplosion() {
    var now = Date.now();
    if (now - lastFired < 1000) return;
    lastFired = now;

    var cartIcon = document.getElementById('cart-icon-bubble');
    var cx, cy;

    if (cartIcon) {
      cartIcon.classList.remove('cart-icon-animate');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('cart-icon-animate');
    }
    // Fire particles in the centre of the visible viewport so nothing covers them
    cx = window.innerWidth / 2;
    cy = window.innerHeight / 2;

    var colors = ['#1a6fd4', '#3a9fff', '#60c0ff', '#ffffff', '#aaddff', '#0050cc', '#88ccff'];
    var count = 16;

    for (var i = 0; i < count; i++) {
      (function (i) {
        var angle = (i / count) * 360 + (Math.random() - 0.5) * 25;
        var dist = 40 + Math.random() * 55;
        var size = 7 + Math.random() * 8;
        var dur = 550 + Math.random() * 350;
        var rad = angle * Math.PI / 180;
        var tx = Math.cos(rad) * dist;
        var ty = Math.sin(rad) * dist;
        var color = colors[i % colors.length];

        var p = document.createElement('div');
        p.style.position = 'fixed';
        p.style.left = cx + 'px';
        p.style.top = cy + 'px';
        p.style.width = size + 'px';
        p.style.height = size + 'px';
        p.style.borderRadius = '50%';
        p.style.background = color;
        p.style.pointerEvents = 'none';
        p.style.zIndex = '2147483647';
        p.style.opacity = '1';
        p.style.transform = 'translate(-50%, -50%) scale(1)';
        p.style.transition = 'opacity ' + (dur / 1000) + 's ease-out, transform ' + (dur / 1000) + 's ease-out';

        document.body.appendChild(p);
        void p.offsetWidth;

        p.style.opacity = '0';
        p.style.transform = 'translate(calc(-50% + ' + tx + 'px), calc(-50% + ' + ty + 'px)) scale(0.1)';

        setTimeout(function () {
          try { document.body.removeChild(p); } catch (e) {}
        }, dur + 150);
      })(i);
    }
  }

  // Method 1: patch cart-notification.open() — most reliable
  if (customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-notification').then(function () {
      var Klass = customElements.get('cart-notification');
      if (Klass && Klass.prototype.open) {
        var origOpen = Klass.prototype.open;
        Klass.prototype.open = function () {
          triggerCartExplosion();
          return origOpen.apply(this, arguments);
        };
      }
    });
  }

  // Method 2: watch cart-notification class for 'active'
  document.addEventListener('DOMContentLoaded', function () {
    var notif = document.querySelector('cart-notification');
    if (notif) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'class' && notif.classList.contains('active')) {
            triggerCartExplosion();
            break;
          }
        }
      }).observe(notif, { attributes: true, attributeFilter: ['class'] });
    }
  });

  // Method 3: fetch intercept
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      var promise = origFetch.apply(window, args);
      if (url.indexOf('/cart/add') !== -1) {
        promise.then(function (r) {
          if (r && r.ok) setTimeout(triggerCartExplosion, 400);
        }).catch(function () {});
      }
      return promise;
    };
  }

  // Method 4: poll cart count — prevCount starts at -1 so first read sets baseline without firing
  var prevCount = -1;
  setInterval(function () {
    var el = document.querySelector('.cart-count-bubble span:first-child');
    var n = el ? (parseInt(el.textContent, 10) || 0) : 0;
    if (prevCount >= 0 && n > prevCount) triggerCartExplosion();
    prevCount = n;
  }, 500);

})();

// === Notify Me When Available ===
(function () {
  // Build modal once
  var modal = document.createElement('div');
  modal.id = 'notify-me-modal';
  modal.className = 'notify-modal';
  modal.setAttribute('hidden', '');
  modal.innerHTML =
    '<div class="notify-modal__overlay"></div>' +
    '<div class="notify-modal__inner">' +
      '<button class="notify-modal__close" aria-label="Close">&times;</button>' +
      '<p class="notify-modal__title">Notify Me When Available</p>' +
      '<p class="notify-modal__product" id="notify-modal-product"></p>' +
      '<input type="email" class="notify-modal__email" id="notify-modal-email" placeholder="Your email address">' +
      '<button type="button" class="notify-modal__submit" id="notify-modal-submit">Send Me a Notification</button>' +
      '<p class="notify-modal__msg" id="notify-modal-msg"></p>' +
    '</div>';
  document.body.appendChild(modal);

  var activeSection = null;

  function openModal(btn) {
    activeSection = btn.dataset.sectionId;
    var title = btn.dataset.productTitle || '';
    var variant = btn.dataset.variantTitle || '';
    var display = variant && variant !== 'Default Title' ? title + ' — ' + variant : title;
    modal.querySelector('#notify-modal-product').textContent = display;
    modal.querySelector('#notify-modal-email').value = '';
    modal.querySelector('#notify-modal-msg').textContent = '';
    modal.querySelector('#notify-modal-msg').className = 'notify-modal__msg';
    modal.removeAttribute('hidden');
    setTimeout(function () { modal.querySelector('#notify-modal-email').focus(); }, 60);
  }

  function closeModal() {
    modal.setAttribute('hidden', '');
    activeSection = null;
  }

  modal.querySelector('.notify-modal__overlay').addEventListener('click', closeModal);
  modal.querySelector('.notify-modal__close').addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  modal.querySelector('#notify-modal-submit').addEventListener('click', function () {
    var email = modal.querySelector('#notify-modal-email').value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setMsg('Please enter a valid email address.', false);
      return;
    }

    var submitBtn = modal.querySelector('#notify-modal-submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    // Find the hidden contact form for this section (has the authenticity_token)
    var productEl = modal.querySelector('#notify-modal-product');
    var msgBody = 'Back in Stock Notification Request\n\nProduct: ' + productEl.textContent;
    if (activeSection) {
      var notifyBtn2 = document.getElementById('NotifyMeBtn-' + activeSection);
      if (notifyBtn2 && notifyBtn2.dataset.productUrl) {
        msgBody += '\nURL: ' + notifyBtn2.dataset.productUrl;
      }
    }

    var contactForm = activeSection
      ? document.getElementById('NotifyContactForm-' + activeSection)
      : document.querySelector('.notify-contact-form');

    if (!contactForm) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send Me a Notification';
      setMsg('Something went wrong — please try again.', false);
      return;
    }

    var emailInput = contactForm.querySelector('[name="contact[email]"]');
    var bodyInput  = contactForm.querySelector('[name="contact[body]"]');
    if (emailInput) emailInput.value = email;
    if (bodyInput)  bodyInput.value  = msgBody;

    // Submit via hidden iframe — avoids CORS/redirect issues, cookies sent automatically
    var frameName = 'ntfy' + Date.now();
    var frame = document.createElement('iframe');
    frame.name = frameName;
    frame.style.display = 'none';
    document.body.appendChild(frame);

    contactForm.target = frameName;
    contactForm.submit();
    contactForm.target = '';

    submitBtn.disabled = false;
    submitBtn.textContent = 'Send Me a Notification';
    setMsg('Done! We\'ll email you when it\'s back.', true);
    setTimeout(closeModal, 2800);
    setTimeout(function () { try { frame.remove(); } catch (e) {} }, 6000);
  });

  function setMsg(text, ok) {
    var el = modal.querySelector('#notify-modal-msg');
    el.textContent = text;
    el.className = 'notify-modal__msg notify-modal__msg--' + (ok ? 'ok' : 'err');
  }

  // Open modal when any notify button is clicked
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.notify-me-btn');
    if (btn) openModal(btn);
  });

  // Update notify button visibility on variant change (pubsub)
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var d = event && event.data;
        if (!d) return;
        var notifyBtn = document.getElementById('NotifyMeBtn-' + d.sectionId);
        if (!notifyBtn) return;
        var v = d.variant;
        if (!v || !v.available) {
          notifyBtn.classList.remove('notify-me-btn--hidden');
          if (v) {
            notifyBtn.dataset.variantId = v.id;
            notifyBtn.dataset.variantTitle = v.title || '';
          }
        } else {
          notifyBtn.classList.add('notify-me-btn--hidden');
        }
      });
    }
  } catch (e) {}

  // Fallback: watch the submit button disabled attribute
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="ProductSubmitButton-"]').forEach(function (submitBtn) {
      var sid = submitBtn.id.replace('ProductSubmitButton-', '');
      var notifyBtn = document.getElementById('NotifyMeBtn-' + sid);
      if (!notifyBtn) return;
      new MutationObserver(function () {
        if (submitBtn.disabled) {
          notifyBtn.classList.remove('notify-me-btn--hidden');
        } else {
          notifyBtn.classList.add('notify-me-btn--hidden');
        }
      }).observe(submitBtn, { attributes: true, attributeFilter: ['disabled'] });
    });
  });

})();

// === Sticky mobile buy bar ===
(function () {
  var realBtn = document.querySelector('.product-form__submit');
  if (!realBtn) return;

  var bar = document.createElement('div');
  bar.className = 'edc-sticky-bar';
  bar.innerHTML =
    '<div class="edc-sticky-bar__info">' +
      '<span class="edc-sticky-bar__title"></span>' +
      '<span class="edc-sticky-bar__price"></span>' +
    '</div>' +
    '<button type="button" class="edc-sticky-bar__btn button button--primary">Add to Cart</button>';
  document.body.appendChild(bar);

  var titleEl = bar.querySelector('.edc-sticky-bar__title');
  var priceEl = bar.querySelector('.edc-sticky-bar__price');
  var barBtn  = bar.querySelector('.edc-sticky-bar__btn');

  function syncState() {
    var h1 = document.querySelector('.product__title h1');
    if (h1) titleEl.textContent = h1.textContent.trim();

    var priceNode = document.querySelector('.price__regular .price-item--regular') ||
                    document.querySelector('.price-item--regular');
    if (priceNode) priceEl.textContent = priceNode.textContent.trim();

    realBtn = document.querySelector('.product-form__submit');
    if (realBtn && realBtn.disabled) {
      barBtn.disabled = true;
      barBtn.textContent = realBtn.querySelector('span') ? realBtn.querySelector('span').textContent.trim() : 'Sold Out';
    } else {
      barBtn.disabled = false;
      barBtn.textContent = 'Add to Cart';
    }
  }

  barBtn.addEventListener('click', function () {
    var btn = document.querySelector('.product-form__submit:not([disabled])');
    if (btn) {
      btn.click();
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  function onScroll() {
    var anchor = document.querySelector('.product-form__submit');
    if (!anchor) return;
    var rect = anchor.getBoundingClientRect();
    var offScreen = rect.bottom < 0 || rect.top > window.innerHeight;
    bar.classList.toggle('edc-sticky-bar--visible', offScreen);
    if (offScreen) syncState();
  }

  syncState();
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
